export default __webpack_public_path__ + "static/media/google-on-your-smartphone-1796337_640.d6c4a1d9.jpg";